export default {
  dataIterator: {
    rowsPerPageText: 'Elementos por página:',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se encontraron coincidencias',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior'
  },
  dataTable: {
    rowsPerPageText: 'Filas por página:'
  },
  noDataText: 'No hay datos disponibles',
  carousel: {
    prev: 'Visual anterior',
    next: 'Visual siguiente'
  },
  errors: {
    codeIncorrect: 'Código incorrecto.',
    errorLogin: 'Error al iniciar sesión',
    qr: {
      notAllowed: 'ERROR: debes permitir acceso a la cámara',
      notFound: 'ERROR: no hay cámara en este dispositivo',
      notSupported: 'ERROR: se requiere contexto seguro (HTTPS, localhost)',
      notReadable: 'ERROR: ¿la cámara ya está en uso?',
      overConstrained: 'ERROR: las cámaras no son adecuadas',
      streamAPINotSupported: 'ERROR: API de transmisión no compatible',
      scanFailed: 'Código QR inválido',
      tableNumberFailed: 'Número de mesa inválido'
    },
    location: {
      inStoreTitle: 'No estás en la tienda',
      inStoreDescription: 'No puedes ordenar para consumir aquí, elige Recoger o Entrega',
      inStoreBtn: 'Aceptar',
      locationDisabledTitle: 'Permite ubicación GPS',
      locationDescription: 'Escanea el código QR nuevamente y permite la ubicación GPS',
      locationBtn: 'Aceptar'
    },
    cart: {
      menuUnavailable: 'Menú no disponible en este horario',
      startShopping: 'Comenzar a ordenar'
    },
    schedule: {
      availableTimes: '{0} solo disponible de {1} a {2}',
      unavailableTimes: '{0} no disponible de {1} a {2}',
      availableDay: '{0} estará disponible {1} a las {2}',
      unavailable: '{0} no disponible. Intenta otro tipo de pedido',
      startScheduling: 'Podrás programar pedidos {0} a las {1}'
    },
    paymentUnsuccessful: 'Pago fallido',
    temporarilyAppear: 'Este cargo puede aparecer temporalmente en tu estado de cuenta',
    pageNotFound: 'Página No Encontrada',
    storeNotFoundMessage: 'La tienda que buscas no se pudo encontrar. Es posible que haya sido movida, eliminada, o que la URL sea incorrecta.'
  },
  common: {
    storeHoursClosedHoliday: "Cerrado",
    today: 'Hoy',
    nextAvailable: 'Próximamente disponible',
    referralButtonText: 'Invita a tus amigos',
    pointsEarned: 'Puntos ganados',
    confirmTitle: 'Confirmar',
    confirmDesc: '¿Seguro que quieres cambiar de pedido para consumir aquí?',
    actionText: 'Sí, cambiar',
    pickup: 'Recoger',
    delivery: 'Entrega',
    availableToDeliver: 'Disponible para entrega',
    notAvailableForDelivery: 'No disponible para entrega',
    loginDescription: '¡Regístrate o inicia sesión para desbloquear cupones y recompensas exclusivas!',
    orderNow: 'Ordenar',
    hours: 'Horario',
    location: 'Ubicación',
    contact: 'Contacto',
    socials: 'Redes',
    snappyWhy: 'Por qué Snappy',
    snappyBlog: 'Blog',
    snappyPricing: 'Precios',
    snappyDemo: 'Reservar una demo',
    snappyCaseStudies: 'Casos de éxito',
    clickToRedeem: 'Clic para canjear',
    apply: 'Aplicar',
    order: 'Ordenar',
    sortByDistance: 'Ordenar por distancia',
    sortByAlpha: 'Ordenar alfabéticamente',
    searchLocations: 'Buscar ubicaciones',
    az: 'A-Z',
    nearest: 'Más cercano',
    atLeast: 'Al menos',
    to: 'a',
    takeout: 'Para llevar',
    or: 'o',
    guest: 'Invitado',
    back: 'Volver',
    other: 'Otro',
    groups: 'Grupos',
    options: 'Opciones',
    edit: 'Editar',
    register: 'Registrarse',
    poweredBy: 'IMPULSADO POR',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phone: 'Teléfono',
    phoneNumber: 'Número telefónico',
    address: 'Dirección',
    storeHours: 'Horario de la tienda',
    onlineOrderAvailableUntil: 'Pedido en línea disponible hasta',
    mobileNumber: 'Celular',
    status: 'Estado',
    points: 'Puntos',
    balance: 'Saldo',
    save: 'Guardar',
    changesSaved: 'Cambios guardados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    message: 'Mensaje',
    loadMore: 'Cargar más',
    loading: 'Cargando...',
    expires: 'Vence',
    login: 'Iniciar / Registrarse',
    tweet: 'Tuitear',
    share: 'Compartir',
    resend: '(Reenviar en: {0})',
    newCode: 'Nuevo código',
    logout: 'Cerrar sesión',
    fillFields: 'Completa todos los campos requeridos',
    invalidEmail: 'Email inválido',
    verify: 'Código de 6 dígitos',
    continue: 'Continuar',
    verifyCode: 'Verificar código',
    sixDigitCode: 'Código de 6 dígitos',
    unlimited: 'Ilimitado',
    upTo: 'hasta',
    selected: 'seleccionado',
    items: 'artículos',
    amount: 'Monto',
    scanQRCode: 'Escanear código QR',
    loadingQRScanner: 'Cargando escáner...',
    reloadQRScanner: 'Recargar',
    open: 'Abierto',
    open2: 'Abierto',
    closed: 'Cerrado',
    closed2: 'Cerrado',
    email: 'Email',
    select: 'Seleccionar',
    ok: "OK",
    okConfirm: "OK",
    off: 'DCTO',
    app: {
      text1: 'Abrir en',
      text2: 'App',
      btn: 'Abrir'
    },
    captcha: {
      main: 'Este sitio está protegido por reCAPTCHA y la',
      privacy: 'Política de Privacidad',
      and: 'y',
      terms: 'Términos de Servicio',
      apply: 'de Google aplican.'
    },
    disclaimer: {
      main: 'Al iniciar sesión, acepto los <link-tos>Términos de servicio</link-tos> y la <link-pp>Política de privacidad</link-pp>. Consiento recibir mensajes SMS y otras comunicaciones digitales, incluidos cupones, ofertas especiales y promociones de {businessName}. Se pueden aplicar tarifas estándar de mensajes y datos.',
      register: 'Al hacer clic en REGISTRARSE aceptas los <link-tos>Términos de Servicio</link-tos> y <link-pp>Política de Privacidad</link-pp> de Snappy. Usaremos SMS para asegurar tu cuenta y enviar notificaciones.'
    },
    addedToCart: 'Añadido "{0}" al carrito',
    yourOrderId: 'Tu ID de pedido es'
  },
  hours: {
    twentyFourHours: 'Abierto 24 horas',
    midNight: 'Medianoche',
    mon: "Lun",
    tues: "Mar",
    wed: "Mié",
    thurs: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
    monday: "Lun",
    tuesday: "Mar",
    wednesday: "Mié",
    thursday: "Jue",
    friday: "Vie",
    saturday: "Sáb",
    sunday: "Dom"
  },
  menu: {
    specialRequests: 'Instrucciones especiales',
    required: 'OBLIGATORIO',
    optional: 'OPCIONAL',
    soldOut: 'Agotado',
    selectMenu: 'Selecciona un menú',
    menuTitle: 'Menú',
    promotionsAndRewards: 'Promociones y recompensas',
    categories: 'Categorías',
    noMenu: 'No hay menú en esta tienda',
    dropdown: 'Menú Desplegable',
    unavailable: 'Menú no disponible',
    available: 'Horario disponible',
    dayAvailable: 'Próximo disponible',
    availableOffHours: 'Menú disponible para pedidos programados',
    menuIsExclusive: 'No se pueden añadir artículos de diferentes menús',
    item: {
      onlyAvailable: 'Disponible',
      available: 'Este artículo solo disponible de {0} a {1}',
      prepTime: 'Este artículo tarda aprox. {0} en prepararse'
    },
    menuAvailability: 'Disponibilidad del menú',
    gotIt: '¡Entendido!',
    onlyAvailable: 'Este menú solo está disponible en horarios específicos:',
    pricingBanner: 'Pida directamente a {2} y ahorre hasta un {0}% en promedio en comparación con {1}'
  },
  cart: {
    title: 'Carrito',
    startShopping: 'Comenzar a ordenar',
    continue: 'Continuar',
    serviceFee: 'Cargo por servicio',
    takeOutOrder: 'PEDIDO PARA LLEVAR',
    backToLogin: 'Volver a inicio',
    enterYourAddress: 'Dirección de entrega',
    startAdding: 'Comienza a añadir artículos del menú.',
    buildOrder: "Añade artículos para continuar",
    currentlyClosed: ' está cerrado. Vuelve en horario apropiado.',
    delivery: 'Entrega',
    pickup: 'Recoger',
    dinein: 'Consumir aquí',
    estTimeHours: 'horas',
    estTimeMins: 'min',
    subtotal: 'Subtotal',
    deliveryFee: 'Cargo por entrega',
    tbd: 'Por determinar',
    deliveryMinimum: 'Mínimo para entrega',
    pickupMinimum: 'Mínimo para recoger',
    tax: 'Impuestos',
    tip: 'Propina',
    tipDriver: 'Propina al repartidor',
    tipStore: 'Apoya con propina',
    rewards: 'Recompensas',
    total: 'Total',
    btnCheckout: 'Pagar',
    addToCart: 'Añadir',
    aiRecommendationsTitle: 'Recomendado para ti',
    aiRecommendationsTitleGuest: 'Recomendado',
    aiRecommendationsSubtitle: 'Según tus pedidos',
    aiRecommendationsSubtitleGuest: 'Populares en esta tienda',
    aiRecommendationsFrom: 'Desde',
    saveCartItem: 'Actualizar',
    clickToSee: 'Ver opciones',
    payWithMembership: 'Pagar con membresía',
    btnSubmitSubOrder: 'Enviar pedido',
    processing: 'Procesando pedido',
    pastOrders: 'Pedidos anteriores',
    discount: 'Descuento',
    btnPayOrder: 'Enviar pedido',
    closeModal: 'Cerrar',
    cartUnavailable: 'Hay artículos en tu carrito que no se pueden ordenar',
    storeUnavailable: 'No disponible',
    storeClosedBtn: 'Tienda cerrada',
    offHourOrderingMaybeAllowed: 'La tienda está cerrada actualmente. Sin embargo, aún puede programar un pedido para más tarde.',
    advanceBookingWindow: 'La tienda está abierta pero aún no acepta pedidos. Puede programar un pedido para más tarde.',
    deliveryUnavailable: 'Entrega no disponible',
    pickupUnavailable: 'Recoger no disponible',
    tooSmallForDelivery: 'Monto insuficiente para entrega (Mín: {0})',
    tooSmallForPickup: 'Monto insuficiente para recoger (Mín: {0})',
    invalidCoupon: 'Cupón inválido',
    cartErrors: 'Errores en carrito',
    removeInvalidItemToContinue: 'Por favor, elimínalo para continuar.',
    discountNotUsed: 'El carrito no puede estar vacío',
    deliveryDisabled: 'Entrega temporalmente deshabilitada',
    pickupDisabled: 'Recoger temporalmente deshabilitado',
    deliveryDisabledUntil: 'Entrega temporalmente deshabilitada<br>hasta {0}',
    pickupDisabledUntil: 'Recoger temporalmente deshabilitado<br>hasta {0}',
    asapClosed: 'Cerrado · Abre {0} a las {1}',
    asapPastCutoff: 'Ya no se aceptan pedidos por hoy',
    asapSuspendedToday: 'Ya no se aceptan pedidos por hoy',
    storeStoppedAcceptingOrders: 'La tienda dejó de aceptar pedidos mientras finalizabas tu compra. Elige una hora programada para continuar.'
  },
  account: {
    accountInfo: 'Información',
    orderHistory: 'Historial',
    paymentMethods: 'Métodos de pago',
    contactInfo: 'Información de contacto',
    membershipInfo: 'Información de membresía',
    member: 'Miembro',
    nonMember: 'No miembro',
    creditCard: 'Tarjeta de crédito',
    nameOnCard: 'Nombre en tarjeta',
    cardNumber: 'Número de tarjeta',
    expires: 'Vence',
    cvc: 'CVC',
    mmyy: 'MM / AA',
    country: 'País de facturación',
    saveCard: 'Guardar tarjeta',
    addPaymentMethod: 'Añadir método',
    deliveryDetails: 'Detalles de entrega',
    noOrderHistory: 'Sin historial',
    noPaymentMethods: 'Sin métodos de pago',
    addPaymentMethodPrompt: 'Añade un método de pago',
    noCreditCards: 'Sin métodos de pago',
    otherPostalCode: 'Para tarjetas no EEUU/Canadá, ingresa cualquier número',
    membership: 'Membresía',
    history: 'Historial',
    payments: 'Pagos',
    offline: 'Pagar en persona',
    orderId: 'ID de Pedido',
    editTitle: 'Editar información personal',
    payment: {
      title: 'Eliminar método de pago',
      body: '¿Seguro que quieres eliminar este método de pago?',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      status: {
        cvcFailed: 'CVC inválido',
        postalCodeFailed: 'Código postal incorrecto',
        expiredCard: 'Tarjeta vencida'
      }
    },
    rewards: {
      redeemFor: 'Canjear por',
      rewardOptions: 'Opciones de recompensa',
      coupons: 'Cupones',
      punchCards: 'Tarjetas de puntos',
      using: 'Usando',
      remaining: 'Restante',
      free: 'Gratis',
      purchases: 'Compras',
      redeem: 'Canjear',
      max: 'Máx',
      points: 'Puntos',
      credits: 'Créditos',
      discount: 'Descuento',
      yourPoints: 'Tus puntos',
      creditsEarned: '{0} ganados',
      worth: 'Valor',
      insufficientFunds: 'No hay suficientes puntos',
      removeFirst: 'Elimina tu opción de recompensa activa',
      punchCardRibbon: '¡Compra {0} {1} más para {2}!',
      selectItem: 'Seleccionar',
      availableInCart: 'Recompensas disponibles en el carrito',
      availableInCartUpdated: '¡Haz clic en tu carrito para usar esta recompensa!',
      alreadyInCart: '"{0}" ya está en tu carrito',
      missingPoints: '¡Necesitas {0} puntos más para esta tarjeta!',
      inEligible: 'No eres elegible para este cupón',
      noExpiration: 'Sin vencimiento',
      noLimitation: 'Sin limitación',
      buy1Get1Free: 'LLEVA 2 PAGA 1',
      buy1Get1PercentOff: 'LLEVA 2 PAGA 1 CON {0}% DE DESCUENTO',
      buy1Get1AmountOff: 'LLEVA 2 PAGA 1 CON ${0} DE DESCUENTO',
      validForSelectItems: 'Válido para artículos seleccionados',
      discountPercentOff: 'Descuento {0}% Off',
      discountAmountOff: 'Descuento {0}{1} Off',
      discountOff: 'Descuento {0} Off',
      discountUpTo: '{0}, hasta {1}',
      maxDiscountReached: 'Descuento máximo de {0} alcanzado',
      maxDiscountOf: 'Hasta {0}',
      maxDiscountOfDetail: 'Descuento máximo de {0}',
      offerExpires: 'La oferta vence: {0}',
      loginPrompt: 'Inicia sesión para ver tus recompensas',
      inPersonRedeemable: 'Solo canjeable en tienda',
      orderRewards: {
        congrats: '¡Felicidades!',
        coupons: 'Tu pedido te otorgó un cupón extra',
        lossFallback: '¡Lo sentimos, no ganaste esta vez! Inténtalo en el próximo pedido'
      }
    }
  },
  storePage: {
    aiRecommendationsCategory: 'Recomendado para ti',
    aiRecommendationsCategoryGuest: 'Recomendado',
    deliveryProvider: {
      robot: 'Robot',
      human: 'Repartidor',
      byRobot: 'Recibir robot afuera',
      byHuman: 'Recibir en la puerta',
      recommended: 'Recomendado por este negocio',
      notSupported: 'Entrega por {0} no disponible para tu dirección',
      deliveryInstructions: 'Los robots no pueden subir escaleras. Necesitarás el código enviado por email para recibir tu comida'
    },
    error: {
      empty: '¡Nada que mostrar!',
      noResults: 'no dio resultados.',
      tryAdjusting: 'Intenta ajustar tu filtro',
      clear: 'Borrar búsqueda'
    }
  },
  order: {
    estimatedTime: 'Tu pedido se ha realizado, estará listo para recoger {0}',
    estimatedTimeDiff: 'Tu pedido se ha realizado, estará listo en aprox. {0}',
    successfulOrder: 'Tu pedido se ha realizado con éxito',
    deliveryAddressInvalid: 'La dirección ingresada es inválida, intenta de nuevo',
    deliveryAddressMustBeSet: 'Debes establecer dirección de entrega',
    deliveryAddressMustBeInRange: 'Tu dirección está fuera del área de entrega',
    noPaymentMethodSelected: 'Selecciona un método de pago',
    insufficientPoints: 'Saldo de membresía insuficiente',
    requiresAdditionalMethod: 'Saldo insuficiente, se requiere segundo método',
    cardMinimumCharge: 'Se deben pagar al menos {0} con tarjeta. Agregue una propina u otro artículo, o pague este pedido con tarjeta.',
    minCardChargeNote: 'Cargo mínimo con tarjeta: {0}',
    applyMembershipInstead: 'Aplicar {0} en su lugar',
    noPaymentMethods: 'Selecciona un método de pago',
    pickUpDetails: 'Detalles de recogida',
    orderDetails: 'Detalles del pedido',
    selectOrderType: 'Selecciona tipo de pedido',
    orderPlaced: 'Pedido realizado',
    orderScheduled: 'Hora programada',
    orderNotes: 'Notas',
    pickUpTime: 'Hora de recogida',
    pickUpDay: 'Día de recogida',
    deliveryTime: 'Hora de entrega',
    deliveryDay: 'Día de entrega',
    deliveryAddress: 'Dirección',
    addressLine1: 'Dirección línea 1',
    addressLine2: 'Dirección línea 2',
    postalCode: 'Código postal',
    city: 'Ciudad',
    payment: 'Pago',
    placeOrder: 'Realizar pedido',
    personalDetails: 'Datos personales',
    tableNumberSet: 'Mesa configurada.',
    onlyOffline: "Esta tienda solo acepta pago en persona.",
    paidOffline: "Se pagará en persona",
    emailReceipt: "Enviar recibo por email",
    offlineEmailReceipt: "Enviar confirmación por email",
    status: {
      new: 'Nuevo',
      inProgress: 'En proceso',
      ready: 'Listo',
      cancelled: 'Cancelado',
      refunded: 'Reembolsado',
      completed: 'Completado'
    },
    orderActions: {
      call: 'Llamar',
      direction: 'Direcciones',
      orders: 'Ver pedidos',
      feedbackTitle: 'Considera dar tu opinión',
      feedbackLabel: 'Dar opinión'
    }
  },
  iosBanner: {
    partOne: 'Toca el ícono compartir',
    partTwo: 'y selecciona añadir a pantalla',
    partThree: 'para instalar'
  },
  checkoutSuccess: {
    text: 'Pago exitoso'
  },
  orderSubmitted: {
    text: 'Pedido enviado'
  },
  deliveryDialog: {
    title: 'Detalles de entrega',
    deliverAsap: 'Entregar ASAP',
    schedule: 'Programar',
    update: 'Actualizar',
    selectAddress: 'Ingresa tu dirección',
    noDeliveryProviders: 'No hay proveedores para esa dirección',
    deliveryAddressSet: '¡Dirección establecida!',
    selectDateTime: 'Selecciona fecha y hora válidas',
    notAvailable: 'No disponible',
    pleaseSelectDate: 'Selecciona una fecha'
  },
  orderDialog: {
    title: 'Detalles de recogida',
    deliveryTitle: 'Detalles de entrega',
    pickUpAsap: 'Recoger ASAP',
    deliverAsap: 'Entregar ASAP',
    schedule: 'Programar',
    done: 'Listo',
    selectDate: 'Selecciona una fecha',
    notAvailable: 'No disponible',
    selectDateTime: 'Selecciona fecha y hora válidas',
    noAvailableDays: "No hay días disponibles",
    earliestDate: "Se ha establecido la fecha más próxima",
    staleTimeBodyGroup: "La tienda no puede tener tu pedido listo para las {0}. Elige una nueva hora para continuar — los artículos de tu grupo e invitados no cambiarán.",
    staleTimeBodySolo: "La tienda no puede tener tu pedido listo para las {0}. Elige una nueva hora para continuar.",
    confirmSlot: "Confirmar {0}",
    goBack: "Volver"
  },
  storeLocation: {
    pickUpAt: 'Recoger en',
    inStore: 'En tienda',
    pickUpTime: 'Hora recogida',
    deliveryTime: 'Hora entrega',
    time: 'Hora',
    deliverTo: 'Entregar a',
    clickToSet: 'Clic para fijar'
  },
  orderTypes: {
    pickup: 'Recoger',
    delivery: 'Entrega',
    dineIn: 'Comer en el restaurante'
  },
  groupOrder: {
    title: 'Pedido grupal',
    namePlaceholder: 'Nombre del pedido grupal',
    from: 'De',
    deliverTo: 'Entregar en',
    pickupAt: 'Recoger en',
    invitePeople: 'Invitar personas',
    chooseWhoPays: 'Elegir quién paga',
    paySubtitle: 'El anfitrión (tú) pagará por todo el pedido grupal. El método de pago se ingresará al finalizar la compra.',
    youPayForEveryone: 'Tú pagas por todos',
    hostWillPayForEveryone: 'El anfitrión pagará por todos',
    limitPlaceholder: 'Ingresa límite por persona (opcional)',
    perPerson: 'por persona',
    everyonePaysThemselves: 'Cada uno paga por sí mismo',
    comingSoon: 'Próximamente',
    next: 'Siguiente',
    yourGroupOrderLink: 'Tu enlace de pedido grupal',
    copy: 'Copiar',
    share: 'Compartir',
    linkCopied: '¡Enlace copiado!',
    join: 'Unirse al pedido grupal de {0}',
    spendingLimit: 'Límite de gasto',
    limitNoLimit: 'Sin límite',
    limitOther: 'Otro',
    joinGroupOrder: 'Unirse al pedido grupal',
    joining: 'Uniéndose...',
    loginToJoin: 'Iniciar sesión para unirse',
    continueAsGuest: 'Continuar como invitado',
    enterYourName: 'Ingresa tu nombre',
    joinOrderDisclaimer: 'Al hacer clic en UNIRSE al pedido, aceptas',
    joinOrder: 'UNIRSE al pedido',
    back: 'Atrás',
    notSet: 'No establecido',
    cancelGroupOrder: 'Cancelar pedido grupal',
    cancelGroupOrderConfirmTitle: '¿Cancelar {0}?',
    cancelGroupOrderConfirmBody: 'Esto terminará el pedido grupal para todos. Todos los participantes serán eliminados.',
    cancelGroupOrderConfirm: 'Sí, cancelar',
    cancelGroupOrderKeep: 'Mantener pedido grupal',
    cartMenuCancelGroup: 'Cancelar pedido grupal',
    cartMenuLeaveGroup: 'Salir',
    cartMenuInvite: 'Invitar personas',
    lockedBannerGuest: 'Este pedido grupal ha sido bloqueado. Contacta al anfitrión para hacer cambios.',
    lockedBannerHost: 'Tu carrito está bloqueado. Aún puedes proceder al pago.',
    unlockMyCart: 'Desbloquear mi carrito',
    othersInGroup: 'Otros en tu grupo ({0} personas)',
    othersHaveAdded: '{0} de {1} han agregado artículos',
    memberHostLabel: '(Anfitrión)',
    memberReadyBadge: 'Listo',
    memberWaitingBadge: 'Esperando',
    memberErrorBadge: 'Artículo no disponible',
    memberCartHasErrors: 'Alguien en tu grupo tiene un artículo no disponible. Elimínalo para continuar.',
    memberNoItems: 'Sin artículos aún',
    unlockMemberCart: 'Desbloquear carrito de {0}',
    removeMember: 'Eliminar a {0}',
    yourItems: 'Tus artículos',
    leaveConfirmTitle: '¿Salir de este pedido grupal?',
    leaveConfirmBody: 'Tus artículos serán eliminados y el anfitrión será notificado.',
    leaveConfirmBtn: 'Salir',
    leaveConfirmKeep: 'Cancelar',
    removeConfirmTitle: '¿Eliminar a {0} del pedido grupal?',
    removeConfirmBody: 'Los artículos de {0} serán eliminados y recibirán una notificación.',
    removeConfirmBtn: 'Eliminar a {0}',
    checkoutConfirmTitle: '¿Están todos listos?',
    checkoutConfirmBody: 'Si continúas, el pedido grupal quedará bloqueado y nadie podrá hacer cambios.',
    unreadyConfirmTitleSingle: '{0} todavía está ordenando',
    unreadyConfirmTitleMulti: '{0} invitados todavía están ordenando',
    unreadyConfirmBody: 'Al pagar, el pedido se cierra para todos.',
    unreadyConfirmWaitingOnPrefix: 'Esperando a ',
    unreadyConfirmWaitingOnSuffix: '.',
    and: 'y',
    andOthers: 'y {0} más',
    checkoutWithCurrentBtn: 'Pagar con sus carritos',
    checkoutWithCurrentSubtext: 'El pedido incluye lo que hayan agregado hasta ahora',
    removeCartsCheckoutBtn: 'Pagar sin ellos',
    removeCartsCheckoutSubtext: 'Sus carritos y artículos se eliminan del pedido',
    errorRemoveUnreadyCarts: 'No se pudieron quitar algunos carritos. Inténtalo de nuevo.',
    groupCartEmpty: 'Agrega al menos un artículo antes de pagar.',
    participantWaiting: 'Esperando...',
    notReadyCount: '{0} participante(s) aún no están listos',
    goToCheckout: 'Ir al pago',
    lockedInGroupOrder: 'Estás en un pedido grupal — no se puede cambiar el tipo de pedido ni la hora.',
    checkoutProcessing: 'Procesando...',
    checkoutBackBtn: 'Volver',
    readyBtn: '¡Estás listo!',
    readyHint: 'El anfitrión realizará el pedido por todos.',
    readyStatus: '¡Estás listo!',
    imReadyBtn: '¡Estoy listo!',
    addItemsBtn: 'Agregar artículos',
    lockedCheckoutBtn: 'Pedido grupal bloqueado',
    lockedTimeoutBtn: 'Pedido bloqueado — tiempo agotado',
    exceedsLimit: 'Supera el límite del pedido grupal',
    snackParticipantLeft: '{0} ha salido del pedido grupal.',
    errorMarkReady: 'Error al marcar carrito como listo. Inténtalo de nuevo.',
    errorCartLocked: 'El anfitrión ha bloqueado el pedido. No puedes hacer cambios ahora.',
    errorUnlockCart: 'No se pudo desbloquear el carrito. Inténtalo de nuevo.',
    errorLockGroup: 'Error al bloquear el pedido grupal. Inténtalo de nuevo.',
    errorLeaveGroup: 'Error al salir del pedido grupal. Inténtalo de nuevo.',
    errorCancelGroup: 'Error al cancelar el pedido grupal. Inténtalo de nuevo.',
    errorUnlockMember: 'Error al desbloquear el carrito. Inténtalo de nuevo.',
    errorRemoveParticipant: 'Error al eliminar al participante. Inténtalo de nuevo.',
    dialogRemovedTitle: 'Has sido eliminado',
    dialogRemovedBody: 'El anfitrión te ha eliminado de este pedido grupal. Tus artículos han sido borrados.',
    dialogLeftTitle: 'Saliste de {0}',
    dialogLeftBody: 'Tus artículos han sido borrados.',
    dialogCancelledTitle: 'Pedido grupal cancelado',
    dialogCancelledBody: 'El anfitrión ha cancelado este pedido grupal.',
    dialogPaidTitle: '¡Pedido realizado!',
    dialogPaidBody: 'Tu pedido grupal ha sido enviado con éxito.',
    dialogRecoveredTitle: 'Tienes un pedido grupal en curso',
    dialogRecoveredHost: 'Eres el anfitrión',
    dialogRecoveredGuest: 'Eres un participante',
    dialogRecoveredBtn: 'Continuar',
    deadlineTitle: 'Establecer fecha límite',
    deadlineSubtitle: '¿Cuándo deben ordenar todos?',
    deadlineDayLabel: 'Ordenar antes del (Día)',
    deadlineTimeLabel: 'Ordenar antes de (Hora)',
    noDeadline: 'Sin fecha límite',
    noDeadlineSet: 'Sin fecha límite establecida',
    deadlineSpecificTime: 'Hora específica',
    orderDeadline: 'Fecha límite de pedido',
    orderBeforeDeadline: 'Ordenar antes de {0}',
    peopleCanOrderAnytime: 'La gente puede ordenar en cualquier momento',
    notAvailableScheduled: 'No disponible para este horario programado',
    deadlineNotAvailableNow: 'La fecha límite no está disponible cuando el tiempo de entrega está configurado en Ahora.',
    noAvailableDeadlineTimes: 'No hay horarios disponibles para una fecha límite. Por favor selecciona un horario de entrega más tarde.',
    noSpendingLimit: 'Sin límite de gasto',
    spendingLimitValue: 'Límite de {0}',
    dialogChangedTitle: 'El pedido fue actualizado por el anfitrión',
    dialogChangedToDelivery: 'Cambiado a Entrega a domicilio',
    dialogChangedToPickup: 'Cambiado a Recogida',
    dialogChangedTime: 'Hora cambiada de {0} a {1}',
    dialogChangedTimeSet: 'Hora programada establecida en {0}',
    dialogChangedTimeCleared: 'Hora programada eliminada (lo antes posible)',
    timeChangedLabel: 'Hora cambiada',
    timeChangedToLabel: 'Hora cambiada a',
    confirmChangeToDelivery: '¿Cambiar a Entrega a domicilio?',
    confirmChangeToPickup: '¿Cambiar a Recogida?',
    confirmChangeTypeBody: 'Esto actualizará el tipo de pedido para todos en el grupo.',
    asap: 'Lo antes posible',
    orderAsap: 'Ordenar lo antes posible',
    now: 'Ahora',
    staleTimeTitle: 'La hora seleccionada ya no está disponible',
    staleTimeNearestSlotLabel: 'Hora disponible más cercana',
    staleTimeChooseAnother: 'Elegir otra hora',
    errorResetSchedule: 'Error al actualizar la hora. Inténtalo de nuevo.',
    errorUpdateSchedule: 'Error al actualizar la hora. Inténtalo de nuevo.',
    errorUpdateScheduleConflict: 'No se pudo actualizar en este momento. Revísalo e inténtalo de nuevo.',
    discountsAtCheckout: 'Descuentos aplicados al pagar',
    deliveryFeeAtCheckout: 'Calculado al pagar',
    feesCalculatedAtCheckout: 'Impuestos, tarifas y descuentos se calculan al pagar',
    exceedsSpendingLimit: 'Este artículo superaría el límite de gasto establecido por el anfitrión.',
    cartFinalized: 'Tu pedido grupal ha sido finalizado. No puedes agregar más artículos.',
    noDeadlineSlots: 'No hay horarios disponibles para establecer un límite de tiempo.',
    errorUpdateDeadline: 'No se pudo actualizar el límite. Inténtalo de nuevo.',
    deadlineUpdated: 'Límite de pedido actualizado: {0}',
    deadlineRemoved: 'Límite de pedido actualizado.',
    shareGroupOrder: '¡Únete a mi pedido grupal!',
    memberLocked: 'Bloqueado',
    snackParticipantLeftHost: '{0} ha salido del pedido grupal.',
    tooltipBadgeNew: 'NUEVO',
    tooltipTitle: 'Cómo funciona el Pedido Grupal',
    tooltipScene1Caption: 'Inicia un pedido grupal desde la página del menú',
    tooltipScene2Caption: 'Establece una fecha límite — y quién paga',
    tooltipScene3Caption: 'Comparte el enlace, o deja que tus amigos escaneen para unirse',
    tooltipScene4Caption: 'Todos añaden a un solo carrito. Un solo pago.',
    tooltipStartBtn: 'Iniciar un Pedido Grupal',
    tooltipGotItBtn: 'Entendido',
    tooltipDemoPeopleJoined: '{0} personas se unieron',
    tooltipDemoDeadlineTimeExample: 'Vie, 10 jul · 12:30 PM',
    tooltipDemoPaySub: 'Tú pagas · límite de $15 cada uno',
    tooltipDemoLinkExample: 'gosnappy.io/g/tonnys-order…',
    tooltipDemoGroupCartLabel: 'Carrito grupal',
    tooltipDemoOneCheckout: 'Un solo pago — tú pagas',
    sheetTitle: 'Los pedidos grupales ya están aquí',
    sheetSubtitle: 'Ordenen juntos — un carrito compartido, un solo pago.',
    sheetBullet1: 'Establece una fecha límite',
    sheetBullet2: 'Tú pagas — o establece un límite de gasto',
    sheetBullet3: 'Invita con un enlace o código QR',
    sheetNotNowBtn: 'Ahora no',
    showHowItWorks: 'Muéstrame cómo funciona',
    hostSetsTip: 'Como anfitrión, tú estableces la propina para todo el pedido grupal.',
    checkoutErrorGeneric: 'Error al pagar. Por favor, inténtalo de nuevo.',
    checkoutErrorInvalidCart: 'Algunos artículos del carrito necesitan atención antes de continuar.',
    checkoutErrorOutOfStock: 'Algunos artículos ya no están disponibles. Elimínalos e inténtalo de nuevo.',
    checkoutErrorMissingSelection: 'Revisa las opciones seleccionadas en un artículo del carrito.',
    checkoutErrorInvalidItem: 'Un artículo del carrito ya no es válido. Elimínalo e inténtalo de nuevo.',
    checkoutErrorPaymentDeclined: 'Tu tarjeta fue rechazada. Prueba con otro método de pago.',
    checkoutErrorPaymentFraud: 'El emisor de la tarjeta rechazó este método de pago. Prueba con otro.',
    checkoutErrorCardDetails: 'Hay un problema con los datos de la tarjeta. Verifícalos e inténtalo de nuevo.',
    checkoutErrorCardExpired: 'Esta tarjeta ha expirado. Prueba con otro método de pago.',
    checkoutErrorPaymentGateway: 'No pudimos procesar el pago. Por favor, inténtalo de nuevo.',
    checkoutErrorNotOpen: 'Este pedido grupal ya no está abierto.',
    checkoutErrorVersionConflict: 'El pedido grupal cambió mientras pagabas. Revísalo e inténtalo de nuevo.',
    checkoutErrorInProgress: 'El pago ya está en proceso.',
    checkoutErrorEmpty: 'El carrito grupal está vacío.',
    checkoutErrorBlocked: 'Algunos participantes aún no están listos.',
  },
  weChat: {
    warning: 'Sal de la página y usa Escáner WeChat',
    title: 'Ingresa número de mesa'
  },
  checkout: {
    addCoupon: 'Añadir cupón',
    couponCode: 'Código cupón',
    title: 'Enviar pedido',
    description: '¿Listo para enviar tu pedido?',
    confirmCancel: 'No',
    confirmApprove: 'Sí',
    onlinePay: 'Pago online',
    weChatPay: 'WeChat Pay',
    unitNumber: 'Nº unidad (opcional)',
    primaryMethod: 'Pago',
    secondaryMethod: 'Segundo método',
    credits: 'Monedero',
    orderHints: 'ej. restricciones dietéticas',
    deliveryHints: 'ej. timbre, dejar en porche, nº de buzón, etc.',
    deliveryOptions: 'Opciones entrega',
    deliveryInstructions: 'Instrucciones',
    orderDisposables: 'Utensilios, popotes, etc.',
    deliveryDisposables: 'Utensilios desechables',
    disposablesIncluded: 'No se incluirán a menos que lo solicites',
    noPaymentMethods: 'No hay opciones disponibles.<br>Contacta a {0}',
    billLoadError: 'No pudimos cargar el total de tu pedido. Por favor intenta de nuevo.',
    applePayFailed: 'No se pudo iniciar Apple Pay. Vuelve a intentarlo o elige otro método de pago.',
    retry: 'Intentar de nuevo',
    confirmDialog: {
      total: 'Total',
      name: 'Nombre tienda',
      location: 'Ubicación',
      deliveryInfo: 'Info entrega',
      deliveryAddress: 'Dirección',
      deliveryPhone: 'Teléfono',
      scheduled: 'Programado',
      pay: 'Pagar',
      pickupTitle: '¿Recoger en la tienda?',
      pickupBody: 'Confirma que recogerás este pedido en la tienda.',
      pickupTime: 'Hora de recogida:',
      beforeYouArrive: 'Antes de llegar',
      yesPickUp: 'Sí, recoger',
      goBack: 'Volver'
    },
    deliveryMessage: {
      leave_at_door: 'Dejar en puerta',
      meet_at_door: 'Recibir en puerta',
      meet_outside: 'Recibir afuera'
    },
    couponTypes: {
      title: 'Tu cupón limita tus opciones de pago a:',
      membership: 'Monedero',
      online: 'Tarjetas',
      wechat: 'WeChat',
      offline: 'En persona'
    }
  },
  qr: {
    manulInput: '¿Escáner no funciona? Ingresa número de mesa.',
    selectTable: 'Número de mesa',
    select: 'Confirmar'
  },
  apps: {
    giftcard: 'Tarjetas de Regalo',
    coupons: 'Comprar cupones',
    deposit: 'Agregar Fondos',
    lineup: 'Lista de Espera',
    reservation: 'Reservaciones'
  },
  requestService: {
    openButton: 'Solicitar servicio',
    title: 'Solicitar atención',
    sent: 'Solicitud enviada',
    login: 'Inicia sesión para usar esta función',
    tableNeeded: 'Establece número de mesa para usar esta función'
  },
  sharedCart: {
    bannerLabel: 'Mesa compartida · Mesa #{0}',
    live: 'En vivo',
    staleItemWarning: 'Actualizado por otro cliente — revise antes de guardar',
    sentToKitchen: 'Enviado a cocina',
    roundSentToKitchen: 'Ronda {0} · Enviado a cocina',
    alreadyOrdered: 'Ya pedido',
    itemCount: '{0} artículos',
    stillOrdering: 'Agregando ahora',
    sending: 'Enviando...',
    reconnected: 'Reconectado a la mesa compartida {0}.',
    joinedTitle: '¡Te has unido a la mesa!',
    joinedBody: 'Ahora estás compartiendo el pedido de esta mesa con todos los demás.',
    completedTitle: '¡Pedido de mesa pagado!',
    completedBody: 'El pago de esta mesa se ha completado. ¡Gracias!',
    billAtPosTitle: 'Cuenta enviada a caja',
    billAtPosBody: 'La cuenta de tu mesa ha sido enviada a caja. Por favor paga ahí para completar tu pedido.',
    cancelledTitle: 'Sesión de mesa finalizada',
    cancelledBody: 'La sesión del carrito compartido de esta mesa ha expirado. Escanee el código QR para iniciar una nueva sesión.',
    roundFired: 'Artículos enviados a cocina.',
    errorFireRound: 'Error al enviar a cocina. Por favor intente de nuevo.',
    errorItemChanged: 'Alguien más ya cambió este artículo — actualizado a la versión más reciente, por favor intente de nuevo.',
    errorMutateCart: 'Eso no funcionó. Por favor intente de nuevo.',
    errorSessionClosed: 'Esta mesa ya ha sido cerrada.',
    sharedTable: 'Mesa Compartida',
    sharedTableActive: '● Mesa Compartida Activa',
    tableLabel: 'Mesa {0}',
    errorStartSharedTable: 'No se pudo iniciar la mesa compartida. Por favor intente de nuevo.',
  },
}